import axios from 'axios';

const CargoSettingModule = {
  namespaced: true,
  loading: false,
  crudLoading: false,
  state: {
    itemEditable: {},
    settings: {},
    helper: {},
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_CRUD_LOADING(state, payload) {
      state.crudLoading = payload;
    },
    SET_SETTING(state, payload) {
      let data = payload.data;
      state.itemEditable = data.item;
      state.settings = data.item;
      state.has_purchase_notice = data.has_purchase_notice;
      state.has_sales_notice = data.has_sales_notice;
      state.company_setting = data.company_setting;
    },
    SET_HELPER(state, payload) {
      state.helper = payload.data;
    },
  },
  actions: {
    getSetting({ commit }) {
      commit('SET_LOADING', true);

      return new Promise((resolve, reject) => {
        axios
          .get(`transport/setting/get-setting`)
          .then((res) => {
            commit('SET_SETTING', {
              data: res.data.result,
            });
            commit('SET_LOADING', false);
            commit('SET_HELPER', {
              data: res.data.result?.helper,
            });
            resolve(res);
          })
          .catch((error) => {
            // console.log(error);
            commit('SET_LOADING', false);
            reject(error);
          });
      });
    },
    updateSetting({ commit }, data) {
      commit('SET_CRUD_LOADING', true);
      return new Promise((resolve, reject) => {
        axios
          .post(`transport/setting/update-setting`, data)
          .then((res) => {
            commit('SET_CRUD_LOADING', false);
            resolve(res);
          })
          .catch((error) => {
            // console.log(error);
            commit('SET_CRUD_LOADING', false);
            reject(error);
          });
      });
    },
  },
  getters: {},
};
export default CargoSettingModule;
